<template>
  <ul
    class="TheHeaderNav header-nav"
    aria-label="Header menu"
  >
    <template
      v-for="menuItem in MENU_HEADER"
      :key="menuItem.slug"
    >
      <TheHeaderNavItem
        v-if="visibleMenuList.includes(menuItem.slug)"
        :name="menuItem.name"
        :children="menuItem.children"
        :path="menuItem.path"
        :clickable="menuItem.clickable"
        :current-app="menuItem.currentApp"
      />
    </template>
  </ul>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useLogin } from 'Store';
import { MENU_HEADER } from '@/config/menu-header';
import TheHeaderNavItem from './TheHeaderNavItem.vue';

export default defineComponent({
  name: 'TheHeaderNav',
  components: {
    TheHeaderNavItem,
  },
  setup() {
    const { isLoggedIn } = useLogin();
    const visibleMenuList = computed(() => (isLoggedIn.value
      ? ['investments', 'portfolio', 'resources']
      : ['investments', 'farm-owners', 'advisors', 'resources']));
    return {
      MENU_HEADER,
      visibleMenuList,
    };
  },
});
</script>

<style lang="sass" scoped>
.header-nav
  align-items: center
  justify-content: center
  display: flex
  list-style-type: none
  padding-left: 0
  @media screen and (max-width: 991px)
    display: none
</style>
